import React from 'react';

const GlowCard = React.forwardRef(
  (
    {
      as: Tag = 'div',
      className = '',
      children,
      wallpaper = true,
      onPointerMove,
      onPointerLeave,
      ...props
    },
    ref
  ) => {
    const wallpaperStyle = wallpaper
      ? {
          backgroundImage: `linear-gradient(180deg, rgba(7, 7, 7, 0.66), rgba(7, 7, 7, 0.82)), url(${
            process.env.PUBLIC_URL + '/WALLPAPER.png'
          })`,
        }
      : undefined;

    const handlePointerMove = (event) => {
      const { currentTarget, clientX, clientY } = event;
      const rect = currentTarget.getBoundingClientRect();
      currentTarget.style.setProperty('--mx', `${clientX - rect.left}px`);
      currentTarget.style.setProperty('--my', `${clientY - rect.top}px`);
      if (onPointerMove) onPointerMove(event);
    };

    const handlePointerLeave = (event) => {
      const { currentTarget } = event;
      currentTarget.style.setProperty('--mx', '50%');
      currentTarget.style.setProperty('--my', '50%');
      if (onPointerLeave) onPointerLeave(event);
    };

    return (
      <Tag
        ref={ref}
        className={`interactive-glow ${className}`.trim()}
        onPointerMove={handlePointerMove}
        onPointerLeave={handlePointerLeave}
        {...props}
      >
        {wallpaper ? <span className="card-wallpaper" style={wallpaperStyle} aria-hidden /> : null}
        {children}
      </Tag>
    );
  }
);

GlowCard.displayName = 'GlowCard';

export default GlowCard;
